import { render, staticRenderFns } from "./bookmark.vue?vue&type=template&id=5cfd2d13&"
import script from "./bookmark.vue?vue&type=script&lang=coffee&"
export * from "./bookmark.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports